module.exports = __webpack_public_path__ + "img/search-interface-symbol.521740a6.png";